<template>
  <div class="ins-panel">
    <div class="ins-cab">
      <h4>Caracterización ante el Ministerio (SNIES)</h4>
      <button v-if="!editando && institucion" class="btn-ins" @click="abrirEditar">Editar</button>
    </div>

    <div v-if="cargando" class="ins-info">Cargando…</div>
    <p v-else-if="!institucion" class="ins-vacio">
      No hay institución registrada. Se siembra con los datos de la consulta pública del SNIES.
    </p>

    <template v-else-if="!editando">
      <div class="ins-datos">
        <div v-for="d in datos" :key="d.etiqueta" class="ins-d">
          <span class="ins-et">{{ d.etiqueta }}</span>
          <span class="ins-val">{{ d.valor }}</span>
        </div>
      </div>

      <!-- Manda la resolución cuando la hay; la casilla solo decide mientras
           no se haya cargado ningún acto. Lo resuelve el backend. -->
      <div class="ins-acreditacion" :class="institucion.acreditacion_vigente ? 'ok' : 'no'">
        <template v-if="institucion.acreditacion_vigente">
          <strong>Acreditada en alta calidad</strong>
          <span v-if="institucion.vence_acreditacion_calculado">
            · vence {{ institucion.vence_acreditacion_calculado }}
          </span>
          <span v-if="institucion.bandera" :class="['ins-bandera', `ins-${institucion.bandera}`]">
            {{ textoBandera }}
          </span>
        </template>
        <template v-else>
          <strong>Sin acreditación institucional vigente</strong>
          — es distinta de la acreditación de cada programa.
        </template>
      </div>

      <!-- Actos administrativos, igual que en un programa -->
      <div class="ins-res">
        <div class="ins-res-cab">
          <h5>Actos administrativos</h5>
          <span class="ins-conteo">{{ institucion.resoluciones?.length ?? 0 }}</span>
        </div>

        <table v-if="institucion.resoluciones?.length" class="ins-tabla">
          <thead>
            <tr><th>Acto</th><th>Número</th><th>Ejecutoria</th><th>Vigencia</th><th>Vence</th><th></th></tr>
          </thead>
          <tbody>
            <tr v-for="r in institucion.resoluciones" :key="r.id_resolucion">
              <td>{{ etiquetaTipoActo(r.tipo_acto) }}</td>
              <td>{{ r.numero ?? '—' }}</td>
              <td>{{ r.fecha_ejecutoria ?? '—' }}</td>
              <td>{{ r.vigencia_anios ? r.vigencia_anios + ' años' : '—' }}</td>
              <td>
                <span v-if="r.fecha_vencimiento" :class="['ins-vence', r.bandera ? `ins-${r.bandera}` : '']">
                  {{ r.fecha_vencimiento }}
                </span>
                <span v-else class="ins-nd">no calculable</span>
              </td>
              <td><button class="btn-quitar-ins" @click="quitarResolucion(r.id_resolucion)">×</button></td>
            </tr>
          </tbody>
        </table>
        <p v-else class="ins-vacio">Sin actos administrativos registrados.</p>

        <div class="ins-nueva-res">
          <select v-model="nuevaRes.tipo_acto" class="ins-input">
            <option value="" disabled>Tipo de acto…</option>
            <option v-for="t in tiposActo" :key="t" :value="t">{{ etiquetaTipoActo(t) }}</option>
          </select>
          <input v-model="nuevaRes.numero" class="ins-input ins-corto" placeholder="Número" />
          <input v-model="nuevaRes.fecha_ejecutoria" type="date" class="ins-input" title="Fecha de ejecutoria" />
          <input v-model.number="nuevaRes.vigencia_anios" type="number" min="1" max="20"
                 class="ins-input ins-corto" placeholder="Años" />
          <button class="btn-ins btn-ins-ok" :disabled="!nuevaRes.tipo_acto" @click="agregarResolucion">
            Agregar
          </button>
        </div>
        <p class="ins-ayuda-res">
          El vencimiento no se escribe: se calcula como ejecutoria + vigencia, igual
          que en los programas.
        </p>
      </div>
    </template>

    <!-- Edición -->
    <div v-else class="ins-form">
      <div class="ins-grid">
        <label>Nombre<input v-model="editando.nombre" class="ins-input" /></label>
        <label>Código SNIES<input v-model="editando.codigo_snies" class="ins-input" /></label>
        <label>NIT<input v-model="editando.nit" class="ins-input" /></label>
        <label>Carácter académico<input v-model="editando.caracter_academico" class="ins-input" /></label>
        <label>Naturaleza jurídica<input v-model="editando.naturaleza_juridica" class="ins-input" /></label>
        <label>Sector<input v-model="editando.sector" class="ins-input" /></label>
        <label>Principal o seccional<input v-model="editando.principal_o_seccional" class="ins-input" /></label>
        <label>Estado<input v-model="editando.estado" class="ins-input" /></label>
        <label>Departamento<input v-model="editando.departamento" class="ins-input" /></label>
        <label>Municipio<input v-model="editando.municipio" class="ins-input" /></label>
        <label>Dirección<input v-model="editando.direccion" class="ins-input" /></label>
        <label>Teléfono<input v-model="editando.telefono" class="ins-input" /></label>
        <label>Norma de creación<input v-model="editando.norma_creacion" class="ins-input" /></label>
        <label>Fecha de la norma<input v-model="editando.fecha_norma" type="date" class="ins-input" /></label>
        <label>Sitio web<input v-model="editando.url" class="ins-input" /></label>
      </div>

      <div class="ins-acred-form">
        <label class="ins-check">
          <input type="checkbox" v-model="editando.acreditada_alta_calidad" />
          Acreditada en alta calidad
        </label>
        <template v-if="editando.acreditada_alta_calidad">
          <label>Resolución<input v-model="editando.resolucion_acreditacion" class="ins-input" /></label>
          <label>Vence<input v-model="editando.vence_acreditacion" type="date" class="ins-input" /></label>
        </template>
      </div>

      <div class="ins-acciones">
        <button class="btn-ins" @click="editando = null">Cancelar</button>
        <button class="btn-ins btn-ins-ok" :disabled="guardando" @click="guardar">
          {{ guardando ? 'Guardando…' : 'Guardar' }}
        </button>
      </div>
      <p v-if="error" class="ins-error">{{ error }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
/**
 * Datos de la institución y su organigrama.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

import { ref, computed, onMounted } from 'vue'
import {
  getInstitucionService,
  actualizarInstitucionService,
  agregarResolucionInstitucionService,
  type InstitucionSnies
} from '@/services/InstitucionSniesService'
import { eliminarResolucionService, getCatalogosSniesService, etiquetaTipoActo } from '@/services/ProgramaSniesService'

const institucion = ref<InstitucionSnies | null>(null)
const cargando = ref(false)
const guardando = ref(false)
const editando = ref<Partial<InstitucionSnies> | null>(null)
const error = ref('')

const datos = computed(() => {
  const i = institucion.value
  if (!i) return []

  return [
    { etiqueta: 'Código SNIES', valor: i.codigo_snies ?? '—' },
    { etiqueta: 'NIT', valor: i.nit ?? '—' },
    { etiqueta: 'Carácter académico', valor: i.caracter_academico ?? '—' },
    { etiqueta: 'Naturaleza jurídica', valor: i.naturaleza_juridica ?? '—' },
    { etiqueta: 'Sector', valor: i.sector ?? '—' },
    { etiqueta: 'Principal o seccional', valor: i.principal_o_seccional ?? '—' },
    { etiqueta: 'Estado', valor: i.estado ?? '—' },
    { etiqueta: 'Domicilio', valor: [i.direccion, i.municipio, i.departamento].filter(Boolean).join(', ') || '—' },
    { etiqueta: 'Teléfono', valor: i.telefono ?? '—' },
    { etiqueta: 'Norma de creación', valor: i.norma_creacion ?? '—' },
    { etiqueta: 'Fecha de la norma', valor: i.fecha_norma ?? '—' },
    { etiqueta: 'Sitio web', valor: i.url ?? '—' }
  ]
})

function abrirEditar() {
  error.value = ''
  editando.value = { ...institucion.value }
}

// ── Actos administrativos ────────────────────────────────────────────
const tiposActo = ref<string[]>([])
const nuevaRes = ref({ tipo_acto: '', numero: '', fecha_ejecutoria: '', vigencia_anios: null as number | null })

/** Lo urgente se dice con palabras, no solo con color. */
const textoBandera = computed(() => {
  const meses = institucion.value?.resoluciones?.find(r => r.bandera === institucion.value?.bandera)?.meses_para_vencer
  if (meses == null) return ''
  return meses < 0 ? `vencida hace ${Math.abs(meses)} meses` : `vence en ${meses} meses`
})

async function agregarResolucion() {
  const resultado = await agregarResolucionInstitucionService({
    tipo_acto: nuevaRes.value.tipo_acto,
    numero: nuevaRes.value.numero || null,
    fecha_ejecutoria: nuevaRes.value.fecha_ejecutoria || null,
    vigencia_anios: nuevaRes.value.vigencia_anios
  })
  if (!resultado.ok) {
    error.value = resultado.error ?? 'No se pudo agregar la resolución'
    return
  }
  nuevaRes.value = { tipo_acto: '', numero: '', fecha_ejecutoria: '', vigencia_anios: null }
  await cargar()
}

// Editar y borrar usan los mismos endpoints que las de un programa.
async function quitarResolucion(id: number) {
  if (await eliminarResolucionService(id)) await cargar()
}

async function cargar() {
  cargando.value = true
  try {
    institucion.value = await getInstitucionService()
  } finally {
    cargando.value = false
  }
}

async function guardar() {
  if (!editando.value) return
  guardando.value = true
  error.value = ''
  try {
    const resultado = await actualizarInstitucionService(editando.value)
    if (!resultado.ok) {
      error.value = resultado.error ?? 'No se pudo guardar'
      return
    }
    editando.value = null
    await cargar()
  } finally {
    guardando.value = false
  }
}

onMounted(async () => {
  await cargar()
  // Mismo catálogo de actos que los programas: no hay dos listas que mantener.
  tiposActo.value = (await getCatalogosSniesService()).tipos_acto
})
</script>

<style scoped>
.ins-panel { border-top: 1px dashed #d6dee6; margin-top: 0.9rem; padding-top: 0.8rem; }
.ins-cab { display: flex; align-items: center; gap: 0.6rem; }
.ins-cab h4 { margin: 0; font-size: 0.86rem; color: #14507d; }
.ins-info, .ins-vacio { font-size: 0.78rem; color: #888; font-style: italic; margin: 0.5rem 0; }

.ins-datos {
  display: grid; grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
  gap: 0.6rem; margin: 0.7rem 0;
}
.ins-d { display: flex; flex-direction: column; gap: 0.1rem; }
.ins-et { font-size: 0.68rem; color: #9aa5b1; text-transform: uppercase; letter-spacing: 0.02em; }
.ins-val { font-size: 0.82rem; color: #24303c; }

.ins-acreditacion { border-radius: 8px; padding: 0.55rem 0.75rem; font-size: 0.78rem; }
.ins-acreditacion.ok { background: #e7f6ec; color: #1d7a3a; }
.ins-acreditacion.no { background: #f5f7fa; color: #4a5b6b; }

.btn-ins {
  margin-left: auto; border: 1px solid #d6dee6; background: white; color: #4a5b6b;
  border-radius: 6px; padding: 0.2rem 0.6rem; font-size: 0.74rem; cursor: pointer;
}
.btn-ins-ok { background: #14507d; color: white; border-color: #14507d; margin-left: 0.4rem; }
.ins-form { margin-top: 0.6rem; }
.ins-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(180px, 1fr)); gap: 0.6rem; }
.ins-grid label { display: flex; flex-direction: column; gap: 0.2rem; font-size: 0.74rem; color: #4a5b6b; }
.ins-input { border: 1px solid #d6dee6; border-radius: 6px; padding: 0.25rem 0.4rem; font-size: 0.76rem; }
.ins-acred-form { display: flex; gap: 0.8rem; align-items: flex-end; flex-wrap: wrap; margin-top: 0.8rem; }
.ins-check { display: flex; align-items: center; gap: 0.35rem; font-size: 0.78rem; color: #374a5c; }
.ins-acciones { display: flex; justify-content: flex-end; margin-top: 0.8rem; }
.ins-error { margin: 0.5rem 0 0; font-size: 0.75rem; color: #b3261e; }

/* Actos administrativos de la IES */
.ins-res { margin-top: 1rem; border-top: 1px solid #eef2f6; padding-top: 0.7rem; }
.ins-res-cab { display: flex; align-items: center; gap: 0.5rem; }
.ins-res-cab h5 { margin: 0; font-size: 0.82rem; color: #14507d; }
.ins-conteo { font-size: 0.72rem; color: #9aa5b1; }
.ins-tabla { width: 100%; border-collapse: collapse; font-size: 0.74rem; margin-top: 0.5rem; }
.ins-tabla th { text-align: left; color: #6b7280; font-weight: 600; padding: 0.2rem 0.4rem; }
.ins-tabla td { padding: 0.22rem 0.4rem; border-top: 1px solid #f0f3f6; }
.ins-nueva-res { display: flex; gap: 0.4rem; flex-wrap: wrap; margin-top: 0.5rem; align-items: center; }
.ins-corto { max-width: 6rem; }
.ins-ayuda-res { font-size: 0.7rem; color: #9aa5b1; margin: 0.3rem 0 0; }
.ins-nd { color: #9aa5b1; font-style: italic; }
.btn-quitar-ins { border: none; background: none; color: #c0392b; cursor: pointer; font-size: 0.95rem; line-height: 1; }
.ins-bandera, .ins-vence { padding: 1px 7px; border-radius: 999px; font-weight: 600; margin-left: 0.3rem; }
.ins-roja { background: #fdecea; color: #b3261e; }
.ins-amarilla { background: #fff6e5; color: #9a6700; }
.ins-verde { background: #e7f6ec; color: #1d7a3a; }
</style>
